<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 轮播图管理
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<!-- 	<el-input placeholder="角色名称" class="handle-input mr10" v-model="personName"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button> -->
				<el-button type="primary" icon="el-icon-circle-plus-outline" @click="createPerson">创建轮播图</el-button>
			</div>
			<el-table :data="lunbolist" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<!-- <el-table-column prop="Id" label="ID" align="center" fixed></el-table-column> -->
				<el-table-column prop="Name" label="轮播预览" align="center" fixed>
					<template #default="scope">
						<el-image class="table-td-thumb" :src="scope.row.ImgUrl" :preview-src-list="[scope.row.ImgUrl]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
						<el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"
							style="color: red;">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>
		</div>
		<!-- 编辑弹出框 查看弹出框-->
		<el-dialog :title="title" v-model="editVisible" width="30%">
			<div class="lunbo_top">
				预览
				<div class="lunbo_top_main">
					<input type="image" :src="imageUrl" v-if="imageUrl==''?false:true"> <br>
				</div>
			</div>
			<div class="lunbo_bottom">
				上传
				<div class="lunbo_bottom_main">
					<el-upload class="upload-demo" limit="1" :file-list="fileList" :before-upload="beforeAvatarUpload">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>
				<span>图片尺寸为1920*600</span><span>图片大小不可以超过 2 M</span>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="editVisible = false" :disabled="isSubmit">取 消</el-button>
					<el-button type="primary" @click="saveEdit('ruleForm')" :disabled="isSubmit">确 定</el-button>
				</span>
			</template>
		</el-dialog>


		<el-dialog title="提示" v-model="isdelete" width="30%">
			<span>您确定删除吗？</span>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="isdelete = false">取 消</el-button>
					<el-button type="primary" @click="deletelubo">确 定</el-button>
				</span>
			</template>
		</el-dialog>

	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				isdelete: false, //删除弹出框
				isSubmit: false,
				imageUrl: '',
				id: '',
				ruleForm: [],
				title: '',
				editVisible: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				lunbolist: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
				pageIndex: 1,
				pageSize: 5,
				pageTotal: '',
				UserId: localStorage.getItem('Id'),
				deleteid:'',//删除的id
			}
		},
		created() {
			this.getid()
			this.getData()
		},
		methods: {
			beforeAvatarUpload(file) {
				console.log(file)
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 1
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过2M!')
				} else if (type != 'xls' && type != 'pdf' && type != 'jpg' && type != 'png' && type != 'xlsx' &&
					type != 'bmp' && type != 'jpeg' &&
					type != 'XLS' && type != 'PDF' && type != 'JPG' && type != 'PNG' && type != 'XLSX' && type !=
					'BMP' && type != 'JPEG') {
					this.$message.error('上传图片必须是 xls / pdf / jpg / png / xlsx / bmp / jpeg 格式!');
				} else {
					let formdata = new FormData()
					formdata.append('file', file)
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "BannerImgUpload",
						headers: {
							"Authorization": "bearer " + this.token
						},
						data: formdata
					}).then((res) => {
						console.log(res.data)
						if (res.data.Message == '请求成功') {
							this.imageUrl = res.data.Data[0].url
							this.$message({
								message: '上传轮播图成功!',
								type: 'success'
							});
							if (this.title == '编辑轮播图') {
								this.ruleForm.Ext = res.data.Data[0].ext
								this.ruleForm.Size = res.data.Data[0].size
								this.ruleForm.ImgUrl = res.data.Data[0].url
							} else {
								this.ruleForm = {
									MenuId: this.id,
									ImgUrl: this.imageUrl,
									Ext: res.data.Data[0].ext,
									Size: res.data.Data[0].size,
									UserId: this.UserId
								}
							}
						} else {
							this.$message.error('上传轮播图失败！')
						}
					})
				}
			},
			//获取首页ID
			getid() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetMenu?pageSize=999999",
					headers: {
						"Authorization": "bearer " + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					res.data.Data.forEach((x) => {
						if (x.Name == '首页') {
							this.id = x.Id
						}
					})
				})
			},
			//创建轮播
			createPerson() {
				this.isSubmit = false
				this.imageUrl = ''
				this.isdisabled = false
				this.ruleForm = []
				this.editVisible = true
				this.title = '创建轮播图'
			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑轮播图'
				this.isdisabled = false
				this.isSubmit = false
				this.imageUrl = row.ImgUrl
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "GetBannerModel?bannerId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			//删除轮播
			handleDelete(index, row) {
				this.isdelete = true
				this.deleteid = row.Id
			},
			deletelubo() {
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "DelBanner?Id=" + this.deleteid,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.isdelete = false
						this.$message({
							message: '删除轮播成功！',
							type: 'success'
						})
						this.getData()
					} else {
						this.$message.error('删除轮播失败！');
					}
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑轮播图') {
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "UpdateBanner",
						data: this.ruleForm,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.editVisible = false
							this.$message({
								message: '修改轮播图成功！',
								type: 'success'
							})
							this.getData()
						} else {
							this.$message.error('修改轮播图失败！');
						}
					})

				} else if (this.title == '创建轮播图') {
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "AddBanner",
						data: this.ruleForm,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.editVisible = false
							this.$message({
								message: '创建轮播图成功！',
								type: 'success'
							})
							this.getData()
						} else {
							this.$message.error('创建轮播图失败！');
						}
					})
				} else {
					this.editVisible = false
				}
			},
			handleNodeClick(data) {
				console.log(data);
			},
			getData() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBanner?pageIndex=" + pageIndex + '&pageSize=' + this
						.pageSize + '&menuId=' + this.id,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Message == '请求成功') {
						this.pageTotal = res.data.Count
						this.lunbolist = res.data.Data
						this.lunbolist.forEach((x) => {
							x.AddTime = x.AddTime.replace('T', ' ')
						})
					} else {
						this.$message.error('角色列表获取失败')
					}
				})
			},
			// handleSearch(){

			// },
		}
	};
</script>

<style scoped lang="less">
	.el-image {
		height: 104px !important;
		width: 250px !important;
	}

	.lunbo_top {
		display: flex;

		.lunbo_top_main {
			width: 500px;
			height: 208px;
			margin-left: 30px;
			border: 1px dashed #409eff;
			overflow: hidden;
			border-radius: 10px;

			input {
				width: 500px;
				height: 208px;
			}
		}

		margin-bottom: 20px;
	}

	.lunbo_bottom {
		display: flex;
		align-items: center;

		span {
			color: red;
			font-weight: bold;
			margin-left: 30px;
		}
	}

	.lunbo_bottom_main {
		height: 40px;
		margin-left: 30px;
	}

	:deep(.el-upload) {
		width: 80px;
		height: 32px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>
